export function SD_extractSmartDataItems(smartData: any[]) {
    return smartData.map((entry) => ({
        id: entry.id,
        type: entry.type,
        key: entry.key,
        value: entry.value,
        source: entry.source,
        date: entry.date,
    }))
}
